import {loadStripe} from '@stripe/stripe-js'
import {dqs, error_handler, get_bugsnag} from '../../lib/util'
import {api} from '../../lib/api'
import {loading} from '../../lib/ui'
import {notify} from '../../lib/notifications'

let stripe = null
let stripe_card_element = null

export async function update_credit_card(event) {
  event.preventDefault()

  const bugsnag = get_bugsnag()
  const submit = dqs('form#update_credit_card button.submit')

  bugsnag.leaveBreadcrumb('update_credit_card: ucc')

  if(cardholder_name.value.trim() === '') {
    return notify('Please enter a cardholder name', 'danger')
  }
  bugsnag.leaveBreadcrumb(`ucc | ${cardholder_name.value}`)

  submit.disabled = 'disabled'

  loading('show', 'Updating your credit card, please wait a few seconds.')

  try {
    const {email, stripe: {customer_id: stripe_customer_id}} = JSON.parse(sessionStorage.user)
    bugsnag.leaveBreadcrumb(`ucc | ${email}, ${stripe_customer_id}`)

    const {token: {id: token}} = await stripe.createToken(stripe_card_element, {
      name: cardholder_name.value,
      address_country: 'NZ'
    })

    const update_credit_card_response = await api.patch(
      `/credit_card`,
      {token, stripe_customer_id}
    )

    if(update_credit_card_response.status !== 200) {
      return error_handler(update_credit_card_response)
    }

    notify(
      'Credit Card Updated. Thanks for your continuing support.',
      'success',
      () => reset_card_element()
    )
  }
  catch(error) {
    error_handler(error)
  }
}

const reset_card_element = () => {
  const cardholder_name = dqs('form#update_credit_card #cardholder_name')
  const form = dqs('form#update_credit_card')
  const submit = dqs('form#update_credit_card .submit')

  cardholder_name.value = ''
  stripe_card_element.unmount()
  stripe_card_element.mount('form#update_credit_card #card_element_container')
  submit.disabled = ''

  if(!submit.dataset.click_attached) {
    submit.dataset.click_attached = true
    form.addEventListener('submit', update_credit_card)
  }
}

export async function update_cc() {
  if(!stripe) {
    stripe = await loadStripe(process.env.CLIENT_STRIPE_PUBLISHABLE_API_KEY)
    stripe_card_element = (stripe.elements()).create(
      'card', {
        hidePostalCode: true,
        style: {base: {padding: '1rem', fontSize: '1.25rem'}}
      }
    )
  }

  reset_card_element()
}
